var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectionOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 7.33333H3.33333M12.6667 7.33333C13.0203 7.33333 13.3594 7.47381 13.6095 7.72386C13.8595 7.97391 14 8.31304 14 8.66667V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V8.66667C2 8.31304 2.14048 7.97391 2.39052 7.72386C2.64057 7.47381 2.97971 7.33333 3.33333 7.33333M12.6667 7.33333V6C12.6667 5.64638 12.5262 5.30724 12.2761 5.05719C12.0261 4.80714 11.687 4.66667 11.3333 4.66667M3.33333 7.33333V6C3.33333 5.64638 3.47381 5.30724 3.72386 5.05719C3.97391 4.80714 4.31304 4.66667 4.66667 4.66667M11.3333 4.66667V3.33333C11.3333 2.97971 11.1929 2.64057 10.9428 2.39052C10.6928 2.14048 10.3536 2 10 2H6C5.64638 2 5.30724 2.14048 5.05719 2.39052C4.80714 2.64057 4.66667 2.97971 4.66667 3.33333V4.66667M11.3333 4.66667H4.66667",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectionOutline);
export default __webpack_public_path__ + "static/media/CollectionOutline.3bb826b1267884045320dcecb0ea9e65.svg";
export { ForwardRef as ReactComponent };